// Unique local SEO content for each priority service-area town.
// Each page intentionally has its own copy — no find-and-replace city swaps.

export const LOCATIONS = [
  {
    slug: "mobile-brake-replacement-dracut-ma",
    city: "Dracut",
    state: "Massachusetts",
    st: "MA",
    metaTitle: "Mobile Mechanic in Dracut, MA | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Dracut, MA. We come to your home or workplace — pads, rotors & calipers with upfront pricing and warranty-backed work. Call or text (978) 967-9860.",
    intro:
      "Dracut is a driving town — from Collinsville to the Navy Yard, most errands, school runs and commutes happen on Routes 38 and 113. All that stop-and-go wears brake pads fast. Instead of losing half a day at a shop on Bridge Street, have your brakes replaced in your own driveway.",
    local:
      "We serve every corner of Dracut, from Dracut Center and Kenwood to East Dracut and the neighborhoods around Lake Mascuppic. Whether you're home near Beaver Brook Farm or at work along Mammoth Road, we bring the full brake shop to you — jack stands, tools, quality parts and all.",
    spots: ["Dracut Center", "Collinsville", "Navy Yard", "Kenwood", "Lake Mascuppic area"],
    faqs: [
      {
        q: "Do you service all of Dracut, MA?",
        a: "Yes. We cover all Dracut neighborhoods — Collinsville, the Navy Yard, Kenwood, East Dracut and everywhere in between, at homes and workplaces.",
      },
      {
        q: "Can you do brakes at my Dracut workplace?",
        a: "Absolutely. Many Dracut customers book us at their employer's parking lot along Route 38 or Mammoth Road so the repair happens while they work.",
      },
      {
        q: "How fast can I get an appointment in Dracut?",
        a: "Most Dracut brake jobs are completed within a few days of booking. Just call or text (978) 967-9860 and we'll lock in a day and time, Monday through Saturday.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-lowell-ma",
    city: "Lowell",
    state: "Massachusetts",
    st: "MA",
    metaTitle: "Mobile Mechanic in Lowell, MA | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Lowell, MA. City driving destroys brakes — we replace pads & rotors at your home or office. Transparent quotes — call or text to book.",
    intro:
      "Lowell traffic is brutal on brakes. The daily grind over the Lord Overpass, down Bridge Street and around downtown's one-ways means constant stopping — and constant pad wear. If your car is squealing or grinding, we come to you, whether you're in the Highlands, the Acre or Belvidere.",
    local:
      "Street parking, tight driveways, apartment lots — we've done brake jobs in all of them across Lowell. You don't need a garage. As long as there's a reasonably flat, safe spot to work, your brakes get replaced while you get on with your day, from UMass Lowell commuters to Downtown office workers.",
    spots: ["The Highlands", "Downtown Lowell", "Belvidere", "The Acre", "Pawtucketville", "South Lowell"],
    faqs: [
      {
        q: "Can you work on my car if it's parked on a Lowell street?",
        a: "In many cases yes, as long as there's safe working room around the vehicle. A driveway or lot is ideal — tell us your parking situation when you book and we'll confirm.",
      },
      {
        q: "My brakes grind in Lowell stop-and-go traffic. Is that urgent?",
        a: "Grinding usually means pads are worn to the metal and damaging your rotors. Book soon — catching it early can be the difference between pads only and a full pad-and-rotor job.",
      },
      {
        q: "Do you service the UMass Lowell area?",
        a: "Yes. We regularly serve students and staff around North, South and East campuses. Call or text and we'll meet you wherever the car is parked.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-chelmsford-ma",
    city: "Chelmsford",
    state: "Massachusetts",
    st: "MA",
    metaTitle: "Mobile Mechanic in Chelmsford, MA | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Chelmsford, MA. Pads, rotors & calipers replaced at your home or office near Route 3 & Drum Hill. Call or text to book today.",
    intro:
      "If you commute on Route 3 from Chelmsford, your brakes live a hard life — highway speeds into sudden backups at Drum Hill wear pads and rotors faster than almost any other driving. We replace them at your home in North Chelmsford or your office near the Cross Point towers.",
    local:
      "Chelmsford customers love the math: no dropping the car off near Drum Hill, no shuttle ride, no burning a Saturday in a waiting room. You pick a time, we show up with the parts, and about an hour later your car stops like it should. Warranty-backed work, upfront pricing, old parts shown to you.",
    spots: ["Chelmsford Center", "North Chelmsford", "Drum Hill area", "Westlands", "South Chelmsford"],
    faqs: [
      {
        q: "Do highway commutes on Route 3 wear brakes faster?",
        a: "Yes — repeated hard stops from highway speed generate more heat and wear. If you commute daily on Route 3, have your brakes inspected around every oil change or two.",
      },
      {
        q: "Can you service my car at my Chelmsford office?",
        a: "Yes. Office parks near Drum Hill and along Route 129 are some of our most common job sites. Your car gets fixed while you're in meetings.",
      },
      {
        q: "How much does brake replacement cost in Chelmsford?",
        a: "Most front or rear pad-and-rotor jobs fall in a straightforward range based on your vehicle. Request a quote with your year, make and model and you'll get an exact, no-surprise price.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-tyngsboro-ma",
    city: "Tyngsboro",
    state: "Massachusetts",
    st: "MA",
    metaTitle: "Mobile Mechanic in Tyngsboro, MA | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Tyngsboro, MA. We come to your driveway or workplace — honest quotes, quality parts, warranty-backed brake repair. Call or text (978) 967-9860.",
    intro:
      "Between the Tyngsborough Bridge backups and Route 3 corridor traffic, Tyngsboro drivers do a lot of braking. When your pads start squealing near Flint Pond or Lake Mascuppic, skip the shop entirely — we bring the brake service to your driveway.",
    local:
      "Tyngsboro's spread-out neighborhoods make shop visits a hassle — a drop-off usually means bumming a ride across town. Our mobile setup solves that: we work where your car already sits, whether that's a driveway near the bridge, a cul-de-sac by Mascuppic, or your workplace along Middlesex Road.",
    spots: ["Tyngsboro Center", "Flint Pond area", "Lake Mascuppic", "Middlesex Road corridor", "West Tyngsboro"],
    faqs: [
      {
        q: "Do you come to all parts of Tyngsboro?",
        a: "Yes — from the bridge area to West Tyngsboro and everywhere around Flint Pond and Lake Mascuppic. If your car is parked there, we can usually service it there.",
      },
      {
        q: "How long does a mobile brake job take in Tyngsboro?",
        a: "A typical front or rear pad-and-rotor replacement takes about 60–90 minutes. Both axles usually run two hours or less.",
      },
      {
        q: "What if my rotors are too worn to save?",
        a: "We measure rotor thickness on site. If they're below spec we replace them — we carry quality rotors and never charge for parts you don't need.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-billerica-ma",
    city: "Billerica",
    state: "Massachusetts",
    st: "MA",
    metaTitle: "Mobile Mechanic in Billerica, MA | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Billerica, MA. Pads & rotors replaced at your home or work — Pinehurst to Nutting Lake. Upfront pricing, book in minutes by call or text.",
    intro:
      "From the Route 3 exits to the lights along Boston Road, Billerica driving is a constant brake workout. When your car starts pulsing or squealing, you don't need to carve out a day for the shop — we replace your brakes in your driveway in Pinehurst, by Nutting Lake, or at your office.",
    local:
      "Billerica is one of our busiest towns, and for good reason: big commuter population, lots of family vehicles, and very little free time. Our customers in Billerica Center, North Billerica and around Nutting Lake book with a quick call or text and have their brakes done the same week — no ride-sharing, no waiting rooms.",
    spots: ["Billerica Center", "Pinehurst", "Nutting Lake", "North Billerica", "East Billerica"],
    faqs: [
      {
        q: "Can you service trucks and SUVs in Billerica?",
        a: "Yes. We handle most cars, SUVs and light trucks. Bigger vehicles sometimes cost a bit more for parts — your quote will reflect your exact vehicle.",
      },
      {
        q: "Do I need to buy the parts before you arrive?",
        a: "No. We supply quality brake pads, rotors and hardware matched to your vehicle, and the parts are covered under our repair warranty.",
      },
      {
        q: "My steering wheel shakes when braking on Route 3. What is that?",
        a: "That's usually warped or unevenly worn front rotors. It's a common Billerica commuter complaint and a standard pad-and-rotor replacement fixes it.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-nashua-nh",
    city: "Nashua",
    state: "New Hampshire",
    st: "NH",
    metaTitle: "Mobile Mechanic in Nashua, NH | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Nashua, NH. We come to you — downtown to Pheasant Lane. Honest quotes, quality parts, warranty-backed repairs. Call or text to book.",
    intro:
      "Nashua driving is a brake killer: Everett Turnpike exits, Main Street lights, Pheasant Lane Mall traffic. If your brakes are squealing or your pedal feels soft, we'll fix them at your home or office — no shop drop-off, no waiting around on Amherst Street.",
    local:
      "We serve all of Nashua, from downtown and the Tree Streets to South Nashua near the Massachusetts line. Apartment lots, office parks, driveways — if your car is parked there, we can usually work there. New Hampshire winters are hard on brake hardware, and we check calipers and slides on every job, not just the pads.",
    spots: ["Downtown Nashua", "South Nashua", "Pheasant Lane area", "Tree Streets", "Amherst Street corridor"],
    faqs: [
      {
        q: "Do NH winters damage brakes?",
        a: "Road salt accelerates rust on rotors and can seize caliper slide pins. That's why every Nashua brake job includes a full hardware and caliper inspection, not just new pads.",
      },
      {
        q: "Can you work in my Nashua apartment parking lot?",
        a: "Usually yes — we've done many brake jobs in lots around South Nashua and downtown. Just confirm your property allows it and give us the space details when booking.",
      },
      {
        q: "Do you charge extra to come to Nashua from Massachusetts?",
        a: "No trip charge within our service area. Nashua is core territory for us — the quote you get is the price you pay.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-hudson-nh",
    city: "Hudson",
    state: "New Hampshire",
    st: "NH",
    metaTitle: "Mobile Mechanic in Hudson, NH | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Hudson, NH. Driveway & workplace brake service — pads, rotors, calipers. Transparent pricing — call or text to book.",
    intro:
      "Hudson sits right at the heart of our service area — Routes 102 and 3A carry our customers to work every morning and us to their driveways every day. If your brakes are grinding on the way over the bridge into Nashua, we'll fix them at your house, often within days of booking.",
    local:
      "From the neighborhoods around Benson Park to the streets off Ferry Street and Lowell Road, Hudson is home turf for our mobile brake service. Many Hudson customers book a morning appointment and have safe, quiet brakes before lunch — without leaving their driveway or arranging a single ride.",
    spots: ["Hudson Center", "Benson Park area", "Ferry Street corridor", "Lowell Road", "Gowing Road area"],
    faqs: [
      {
        q: "Is there a travel fee to Hudson, NH?",
        a: "Never. Hudson is central to our service area — you pay for the repair, not the drive.",
      },
      {
        q: "Can you do both axles in one visit?",
        a: "Yes. Front and rear together usually takes about two hours in your Hudson driveway, and doing both at once is the most cost-effective way to book.",
      },
      {
        q: "What warranty do I get in Hudson?",
        a: "Every brake job is warranty-backed on parts and labor, in writing. If something we installed fails under normal use, we come back and make it right.",
      },
    ],
  },
  {
    slug: "mobile-brake-replacement-pelham-nh",
    city: "Pelham",
    state: "New Hampshire",
    st: "NH",
    metaTitle: "Mobile Mechanic in Pelham, NH | My Mobile Mechanic",
    metaDesc:
      "Mobile brake replacement in Pelham, NH. Quiet, safe brakes without the shop trip — we come to your home or workplace. Call or text (978) 967-9860 to book.",
    intro:
      "Pelham's rural roads mean fewer shops nearby — which is exactly why mobile brake replacement makes sense here. Instead of driving a grinding car down Route 38 to a garage, let the garage come to you. We serve all of Pelham, from the town center to the Windham and Dracut lines.",
    local:
      "Long driveways and quiet streets make Pelham ideal for mobile service. We regularly work near Pelham Center, Muldoon Park and the neighborhoods along Mammoth Road. You call or text to book, we arrive with the parts, and your brakes are done while you're inside your own house.",
    spots: ["Pelham Center", "Muldoon Park area", "Mammoth Road corridor", "Route 38 neighborhoods", "Windham line area"],
    faqs: [
      {
        q: "Do you really come out to Pelham?",
        a: "Yes — Pelham is a priority service town for us. No travel fee, and most appointments are available within a few days.",
      },
      {
        q: "My driveway is long and gravel. Can you still work?",
        a: "Usually yes. We need a reasonably firm, level spot to lift the vehicle safely. Tell us about your surface when booking and we'll confirm before the appointment.",
      },
      {
        q: "How do I pay for my Pelham brake job?",
        a: "You'll approve an exact quote before we start. Payment is collected when the work is complete — no prepayment required.",
      },
    ],
  },
];

export const locationBySlug = (slug) => LOCATIONS.find((l) => l.slug === slug);
